<template>
  <div class="investor-report" v-cloak>
    <div class="report-box" v-for="(item, index) in list" :key="index">
      <div class="report-date-box">
        <div class="report-day">{{extractDay(item['publishDate'])}}</div>
        <div class="report-date">{{extractYearAndMonth(item['publishDate'])}}</div>
      </div>
      <a :href="getPdfDownloadUrl(item)" target="_blank" class="report-title">{{item['title']}}</a>
      <a class="report-read" :href="getPdfDownloadUrl(item)" target="_blank">阅读报告</a>
    </div>
    <infinite-loading class="infinite" @infinite="infiniteHandler">
      <div slot="spinner">加载中...</div>
      <div slot="no-more">没有更多数据了</div>
      <div slot="no-results">没有数据</div>
      <div slot="error" slot-scope="{ trigger }">
        加载错误, <a href="javascript:;" @click="trigger">重新加载</a>
      </div>
    </infinite-loading>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import Bus from '../../router/bus.js';
  /**
   * 通用报告
   */
  export default {
    name: 'InvestorReport',
    props: {
      cat: {
        required: true
      }
    },
    components: {
      InfiniteLoading
    },
    data() {
      return {
        page: 0,
        list: []
      }
    },
    created() {
      Bus.$emit('changeCat', this.cat)
    },
    methods: {
      getPdfDownloadUrl(item) {
        if (navigator.userAgent.indexOf('Android') > -1) {
          let tmp = item['pdfFile'].split('url=');
          return '/pdfjs/web/viewer.html?url=' + tmp[1] + '&title=' + encodeURIComponent(item['pdfFileName']);
        } else {
           let tmp = item['pdfFile'].split('url=');
           return '/pdfjs/web/viewer.html?url=' + tmp[1] + '&title=' + encodeURIComponent(item['pdfFileName']);
        }
      },
      infiniteHandler($state) {
        let url = this.$root.baseUrl + '/investorReport/list/' + this.cat + '/' + this.page + '?title=&publishDate=';
        this.axios.get(url).then(({ data }) => {
          if (data['content'].length > 0) {
            this.page += 1;
            this.list.push(...data['content']);
            console.log(this.list);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      },
      extractDay(date) {
        let tmp = date.split('-');
        return tmp.pop();
      },
      extractYearAndMonth(date) {
        let tmp = date.split('-');
        tmp.pop();
        return tmp.join('-');
      }
    }
  };

</script>
<style scoped>
  .investor-report {
    font-size: 1rem;
    padding-top: 1rem;
  }
  .report-box {
    font-size: 1rem;
    position: relative;
    padding-left: 6rem;
    margin: 2rem 2rem;
  }
  .report-date-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 5rem;
    border-right: 1px solid #f5f5f5;
    text-align: center;
  }
  .report-day {
    font-size: 3rem;
    font-family: Arial,serif;
    font-weight: 600;
    color: #666666;
  }
  .report-date {
    font-size: 1rem;
    color: #9c9c9c;
  }
  a.report-title {
    display: block;
  }
  .report-title {
    color: #565656;
  }
  .report-read {
    color: #919191;
  }
  .report-read:hover, .report-read:active {
    color: #ff9539;
  }
  .infinite {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/investor/InvestorReport.vue